import React from "react";
import styled from "styled-components";

import { DataDefinition } from "../../rule-engine-core/Common/Data/DataDefinition";
import { IDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import VariablePicker from "../VariablePicker/VariablePicker";
import { ObserveState } from "../StateManagement/ObserveState";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { Box, SxProps } from "@mui/material";
import { getPropertyEditorValidationIssues, PropertyEditorValidationTooltip } from "./PropertyEditorValidationTooltip";

export interface PropertyEditorVariableSelectionInterface {
    label?: string;
    hint?: string;
    editObject: object;
    propertyName: string;
    inputDataFunction: () => DataDefinition;
    expectedType: IDataDefinition;
    allowNew: boolean;
    onChange?: () => void;
    sx?: SxProps;
    error?: string;
    ignoreDesignerValidation?: boolean;
}

export const PropertyEditorVariableSelection: React.FC<PropertyEditorVariableSelectionInterface> = (
    props: PropertyEditorVariableSelectionInterface,
) => {
    return (
        <ObserveState
            listenTo={props.editObject}
            properties={[props.propertyName]}
            control={() => {
                const path = Reflect.get(props.editObject, props.propertyName);
                let validationIssues = getPropertyEditorValidationIssues(
                    props.editObject,
                    props.propertyName,
                    props.error,
                );

                return (
                    <PropertyEditorValidationTooltip
                        editObject={props.editObject}
                        propertyName={props.propertyName}
                        error={validationIssues}
                    >
                        <PropertyEditorVariableSelectionRender sx={props.sx}>
                            <VariablePicker
                                label={props.label}
                                selected={path}
                                hint={props.hint}
                                size={"small"}
                                error={validationIssues?.message}
                                allowNewVariable={props.allowNew}
                                onVariableSet={(newpath: string) => {
                                    Reflect.set(props.editObject, props.propertyName, newpath);
                                    StateManager.propertyChanged(props.editObject, props.propertyName);
                                    if (props.onChange) props.onChange();
                                }}
                                data={props.inputDataFunction()}
                                requiredType={props.expectedType.type}
                                isList={props.expectedType.list}
                                fullWidth={true}
                                sx={props.sx}
                            />
                        </PropertyEditorVariableSelectionRender>
                    </PropertyEditorValidationTooltip>
                );
            }}
        />
    );
};

const PropertyEditorVariableSelectionRender = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
